import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from './data.service';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { IPataviumPagedResponse } from '../helpers/response.class';
import { IProvinceResponse } from '../models/request-and-responses/rest-api/interfaces/provinceResponse';
import { HttpClient } from '@angular/common/http';
import { ISupplierResponse } from '../models/request-and-responses/rest-api/interfaces/supplierResponse';
import { IVendorResponse } from '../models/request-and-responses/rest-api/interfaces/distributorResponse';
import { EnergyOrGasContract } from '../models/request-and-responses/rest-api/enums/energyOrGasContract.enum';
import { Observable } from 'rxjs/Observable';
import { SieveOperator, SieveString } from '../helpers/sieve/sieveString.class';
import { SieveFilter } from '../helpers/sieve/sieve-filters-and-sorts';

@Injectable()
export class AutocompleteService {
    private readonly dataService: DataService;

    constructor(private router: Router, private http: HttpClient, dataService: DataService) {
        this.dataService = dataService;
    }

    public apiCities = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            switchMap(term =>
                this.dataService
                    .getLikeNameCity(term)
                    .pipe(map(response => response.payload.map<string>(c => c.name)))
            )
        );

    public apiProvinces = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            switchMap(term =>
                this.dataService
                    .getLikeNameProvince(term)
                    .pipe(
                        map((response: IPataviumPagedResponse<IProvinceResponse>) =>
                            response.payload.map<string>(c => c.sigla)
                        )
                    )
            )
        );

    public apiSupplier = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            switchMap(term => {
                    const sieveString = new SieveString();
                    sieveString.addFilters([
                        {
                            key: SieveFilter.Supplier.Name,
                            operator: SieveOperator.Contains,
                            value: term
                        }
                    ]);
                    return this.dataService
                        .getSuppliers(sieveString)
                        .pipe(
                            map((response: IPataviumPagedResponse<ISupplierResponse>) =>
                                response.payload.map<string>(c => c.name)
                            )
                        );
                }
            )
        );

    public apiDistributorGas = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            switchMap(term => {
                    const sieveString = new SieveString();
                    sieveString.addFilters([{
                        key: SieveFilter.Distributor.Name,
                        operator: SieveOperator.Contains,
                        value: term
                    }, {
                        key: SieveFilter.Distributor.Type,
                        operator: SieveOperator.Equal,
                        value: EnergyOrGasContract.Gas
                    }]);
                    return this.dataService
                        .getDistributors(sieveString)
                        .pipe(
                            map((response: IPataviumPagedResponse<IVendorResponse>) =>
                                response.payload.map<string>(c => c.name)
                            )
                        );
                }
            )
        );

    public apiDistributorEnergy = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            switchMap(term => {
                const sieveString = new SieveString();
                sieveString.addFilters([{
                    key: SieveFilter.Distributor.Name,
                    operator: SieveOperator.Contains,
                    value: term
                }, {
                    key: SieveFilter.Distributor.Type,
                    operator: SieveOperator.Equal,
                    value: EnergyOrGasContract.Energy
                }]);
                    return this.dataService
                        .getDistributors(sieveString)
                        .pipe(
                            map((response: IPataviumPagedResponse<IVendorResponse>) =>
                                response.payload.map<string>(c => c.name)
                            )
                        );
                }
            )
        );
}



// WEBPACK FOOTER //
// ./src/app/services/autocomplete.service.ts